import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['switchable']

  toggle() {
    this.switchableTargets.forEach(target => {
      target.classList.toggle('hidden')
    })
  }
}
